<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28">
  <path
    fill="#cc4121"
    d="M8.408 27.5.5 19.592V8.408L8.408.5h11.184L27.5 8.408v11.184L19.592 27.5z"
  />
  <path
    fill="#fffaee"
    d="M19.414 10.707 16.121 14l3.293 3.293-2.121 2.121L14 16.121l-3.293 3.293-2.121-2.121L11.879 14l-3.293-3.293 2.121-2.121L14 11.879l3.293-3.293 2.121 2.121ZM19.592.5H8.408L.5 8.408v11.184L8.408 27.5h11.184l7.908-7.908V8.408L19.592.5ZM26 18.97 18.97 26H9.03L2 18.97V9.029L9.03 2h9.941L26 9.029v9.941Z"
  />
  <path
    fill="#231f20"
    d="M17.293 7.879 14 11.172l-3.293-3.293-2.828 2.828L11.172 14l-3.293 3.293 2.828 2.828L14 16.828l3.293 3.293 2.828-2.828L16.828 14l3.293-3.293-2.828-2.828ZM15.414 14l3.293 3.293-1.414 1.414L14 15.414l-3.293 3.293-1.414-1.414L12.586 14l-3.293-3.293 1.414-1.414L14 12.586l3.293-3.293 1.414 1.414L15.414 14Zm4.385-14H8.201L0 8.201v11.598L8.201 28h11.598L28 19.799V8.201L19.799 0ZM27 19.385 19.385 27H8.615L1 19.385V8.615L8.615 1h10.77L27 8.615v10.77Z"
  />
</svg>
